import { z } from "zod";

export const INSTANT_BOOK_CONFIGURATION = ["ON", "REQUEST_TO_BOOK"] as const;

export const requestToBookSchema = z.object({
  autoApprovePreviousApprovedWorkers: z.boolean(),
  autoApprovePastWorkers: z.boolean(),
  qualifications: z.array(z.string()),
  shiftTimeSlots: z.array(z.string()),
});

export const updateInstantBookSchema = z
  .object({
    instantBook: z.enum(INSTANT_BOOK_CONFIGURATION),
    requestToBook: requestToBookSchema.optional(),
  })
  .refine((data) => Object.keys(data).length > 0, {
    message: "At least one attribute must be provided",
  });

export const workplaceProfileUpdateSchema = z.object({
  data: z.object({
    id: z.string(),
    type: z.literal("workplace"),
    attributes: updateInstantBookSchema,
  }),
});

export type UpdateInstantBookRequest = z.infer<typeof updateInstantBookSchema>;

export const workplaceResponseSchema = z.object({
  data: z.object({
    id: z.string(),
    type: z.literal("workplace"),
    attributes: z
      .object({
        instantBook: z.enum(INSTANT_BOOK_CONFIGURATION),
        requestToBook: requestToBookSchema.optional(),
      })
      .optional(),
  }),
});

export type WorkplaceResponse = z.infer<typeof workplaceResponseSchema>;
